module.exports = __webpack_public_path__ + "/6781d7252d5ab7b7310eecf11baf10fa.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/assets/daily_reminder_icon.svg
 ** module id = 1638
 ** module chunks = 0
 **/